export const Name = 'errorComponentComponent';
